
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link as LinkIcon } from 'lucide-react';
import { Editor } from '@tiptap/react';
import LinkDialog from './LinkDialog';

export default function LinkButton({ editor }: { editor: Editor }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <Button
        size="icon"
        variant={editor.isActive('link') ? 'secondary' : 'ghost'}
        onClick={e => {
          e.preventDefault();
          setIsOpen(o => !o);
        }}
        className="h-8 w-8"
        title="Link"
        type="button"
      >
        <LinkIcon className="h-4 w-4" />
      </Button>
      <LinkDialog isOpen={isOpen} onClose={() => setIsOpen(false)} editor={editor} />
    </div>
  );
}
